import logo from '../../../../assets/logo.png'

const NavImg = props => {

    return <a
        className="logo"
        href="/"
        alt='九尾陆吾'
    >
        <img src={logo} alt="" />
        <div className='title'>九尾陆吾</div>
    </a>
}

export default NavImg
